import { createSocket, sendWSPush, disConnectSocket } from "@/utils/websocket.js";
import { getRoomDetail } from "@/api/work";

const VRMixin = {
  data() {
    return {
      mixin_isVRShow: false,
      mixin_isController: false,
      mixin_roomInfo: undefined,
      minxin_participantList:[],
      minxin_hostInfo: undefined,
      minxin_timeStr: "00:00",
      minxin_timer: null,
      minxin_totalCount: 0,
      minxin_initqueue: [],
    }
  },

  created() {
    // 帶看頁面才進行socket鏈接
    if(this.$route.name === "VRTour") {
      this.mixin_isVRShow = true;
      this.mixin_isController = this.$route.params.role == "1";
      const houseId = this.$route.params.houseId
      // 獲取房間信息
      getRoomDetail({id: houseId}).then((res) => {
        this.mixin_roomInfo = res.data;
        this.startCount();
      })
      
      // 連接socket
      createSocket();
      // 發送房建號給後台
      sendWSPush({cmd: 0, data: houseId})
      console.log("發送房建號給後台=", houseId);
      this.getMessages();
    }
  },

  methods: {
    getMessages() {
      window.addEventListener('onmessageWS', this.setNoticeData)
    },

    sendMessage(data) {
      sendWSPush(data)
    },

    // 開始計時
    startCount() {
      this.minxin_timer && clearInterval(this.minxin_timer);
      this.minxin_timer = setInterval(() => {
        this.minxin_totalCount += 1;
        const min = parseInt(this.minxin_totalCount / 60) % 60;
        const minStr = min < 10 ? "0"+min : min;
        const second =  this.minxin_totalCount % 60;
        const secStr = second < 10 ? "0"+second : second;
        this.minxin_timeStr = minStr + ":" + secStr;
      }, 1000)
    },

    // 處理帶看用戶列表
    handleUSerList(list) {
      let newList = [];
      for(let key in list) {
        const item = list[key];
        if(this.mixin_roomInfo.uid == key) {
          // 房主信息
          this.minxin_hostInfo = item;
        } else {
          newList.push(item)
        }
      }
      console.log("用戶列表====", newList)
      this.minxin_participantList = newList
    }

  },
  destroyed() {
    disConnectSocket();
    // 停止計時
    this.minxin_timer && clearInterval(this.minxin_timer);
    this.minxin_timer = null;
  },
}

export default VRMixin;
